import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { DeleteCourier, ModeOfTransport } from "../../../types/CourierTypes";
import { CourierShippingOption, CourierShippingOptionRequestPayload } from "../../../types/CourierShippingOptionsTypes";
import { ActivationStatus } from "../../../types";

// Async Thunks
export const fetchCourierShippingOptions = createAsyncThunk<CourierShippingOption[], { status?: ActivationStatus, courierId?: string, modeOfTransport?: ModeOfTransport }, { rejectValue: string }>("courierShippingOptions/fetchCourierShippingOptions", async ({ status, courierId, modeOfTransport }, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<CourierShippingOption[]>>(apiEndpoints.courierShippingOptions.getAll, {
      params: {
        status,
        courierId,
        modeOfTransport
      }
    });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch courier shipping options.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createCourierShippingOption = createAsyncThunk<CourierShippingOption, CourierShippingOptionRequestPayload, { rejectValue: string }>("courierShippingOptions/createCourierShippingOption", async (newCourierData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<CourierShippingOption>>(apiEndpoints.courierShippingOptions.create, { data: newCourierData });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add courier shipping option.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const deleteCourierShippingOption = createAsyncThunk<DeleteCourier, { id: string }, { rejectValue: string }>("courierShippingOptions/deleteCourierShippingOption", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await api.delete<ApiResponse<DeleteCourier>>(`${apiEndpoints.courierShippingOptions.delete}/${id}`);
    if (response?.success) {
      return { ...response.data, id };
    } else {
      throw new Error(response.message || "Failed to delete courier shipping option.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateCourierShippingOption = createAsyncThunk<CourierShippingOption, CourierShippingOptionRequestPayload, { rejectValue: string }>("courierShippingOptions/updateCourierShippingOption", async (updatedCourierData, { rejectWithValue }) => {
  try {
    const response = await api.put<ApiResponse<CourierShippingOption>>(`${apiEndpoints.courierShippingOptions.update}/${updatedCourierData?.id}`, { data: updatedCourierData });
    if (response?.success) {
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update courier shipping option.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
